import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ViewportService } from '@shared/services/viewport.service';
import { LocaleService } from '@shared/services/locale.service';
import { NumbersService } from '@shared/services/numbers.service';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { ApiService } from '@shared/services/api.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SnackService } from '@shared/services/snack.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '@shared/services/auth.service';
import { User } from '@core/models';
declare const Stripe;

@Component({
	selector: 'app-payment',
	templateUrl: './payment.component.html',
	styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit {
	constructor(
		private title: Title,
		private api: ApiService,
		private router: Router,
		private route: ActivatedRoute,
		private snack: SnackService,
		public viewport: ViewportService,
		public locale: LocaleService,
		public numbers: NumbersService,
		private auth: AuthService
	) {}

	embedded: boolean = false;
	loading: boolean = false;
	vouchers: string[] = [];
	queryPackage: string;
	ad_voucher: boolean = false;
	fastpay: boolean = false;
	stripe1: boolean = false;
	fast_pay: boolean = false;
	paymentHandler: any = null;
	user: User = this.auth.user();
	productType: string;
	adID: any;
	isSubmit = false;
	category: string = '0';
	pay: string = '15000 IQD';
	billingType = new FormControl('voucher');
	adId: any;
	adTitle: any;
	checkpaymentMethod = 1;
	voucherCompany = [];

	onFastpay() {
		this.fastpay = true;
	}

	async setvoucherTitle() {
		this.loading = true;

		const formData: FormData = new FormData();
		formData.append('lang', this.locale.lang);
		formData.append('userID', this.user['userID']);
		formData.append('adID', this.adId);

		this.api.ad(formData).subscribe((res) => {
			this.loading = false;

			if (res.status === '1') {
				this.adTitle = res.response.data.title;
			} else if (res.status === '0') {
				this.adTitle = '';
			}
		});
	}

	async onStripePayment() {
		this.loading = true;

		if (this.category === '15' || this.category === '17' || this.category === '0') {
			this.productType = '1';
		} else {
			this.productType = '2';
		}

		const stripe = Stripe(environment.stripe_key);
		const formData: FormData = new FormData();
		formData.append('lang', this.locale.lang);
		formData.append('adID', this.adId);
		formData.append('isBasic', this.queryPackage === 'basic' ? '1' : this.queryPackage === 'vip' ? '0' : '');

		if (this.embedded) {
			formData.append('embedded', this.embedded ? '1' : '0');
		}

		this.api.createSession(formData).subscribe(async (res) => {
			this.loading = false;

			if (res.status === '1') {
				stripe
					.redirectToCheckout({
						sessionId: res.response.sessionID,
					})
					.then((result) => {
						console.log(result);
					});
			} else {
				this.snack.open(this.locale.translations['misc']['n174']);
			}
		});
	}

	onPaymentMode(paymentmode: string): void {
		this.router.navigate(['./provider'], {
			relativeTo: this.route,
			queryParams: {
				adID: this.adId,
				mode: paymentmode,
				package: this.queryPackage,
			},
		});
	}

	ngOnInit(): void {
		this.title.setTitle(this.locale.translations['payment']['n209'] + ' | ' + this.locale.translations['header']['n0']);
		this.route.queryParams.subscribe((queries: Params) => {
			if (queries['title']) {
				this.adTitle = queries['title'];
			}

			if (queries['adID']) {
				this.adId = queries['adID'];
				this.setvoucherTitle();
			}

			if (queries['package']) {
				this.queryPackage = queries['package'];
			}

			if (queries['Cat']) {
				this.category = queries['Cat'];
			}

			this.embedded = queries['embedded'];

			if (this.queryPackage === 'premium') {
				this.productType = ' 2';
			} else if (this.queryPackage === 'vip') {
				this.productType = '1';
			}
		});
	}
}
